import React from 'react';

import StarRating from '../../library/star-rating/star-rating';
import Typography from '../../library/typography/typography';
import ProductBrandLogo from './components/product-brand-logo/product-brand-logo';
import ProductCode from './components/product-code/product-code';
import ProductGBB from '../product-gbb/product-gbb';
import ProductTitle from '../product-title/product-title';

import { getNormalizedGBB } from '../../shared/utils/product/product';

import { Maybe } from '../../shared/types/graphql-types';

import './product-description.scss';

interface ProductContainsDescriptionProps {
  brand?: Maybe<string>;
  brandLogoUrl?: Maybe<string>;
  className?: string;
  code?: Maybe<string>;
  gbb?: Maybe<string>;
  isOE?: boolean;
  link?: Maybe<string>;
  name?: Maybe<string>;
  onClick?: () => void;
  productType?: Maybe<string>;
  showGBBTooltip?: boolean;
  showRating?: boolean;
  size?: Maybe<string>;
  subDescription?: Maybe<string>; //TODO: Remove this prop if OW-4656 can be completed by the backend
  totalRating?: number;
}

function ProductDescription(props: ProductContainsDescriptionProps) {
  const {
    brand,
    brandLogoUrl,
    className,
    code = '',
    gbb,
    isOE = false,
    link,
    name,
    onClick,
    showGBBTooltip,
    showRating = false,
    size,
    subDescription,
    totalRating
  } = props;

  return (
    <div
      className={`${className || ''} product-description`}
      styleName="description"
    >
      {brandLogoUrl && (
        <ProductBrandLogo brand={brand} brandLogoUrl={brandLogoUrl} />
      )}

      <ProductTitle
        brand={brand}
        className={`product-description__title ${
          className ? `${className}__title` : undefined
        }`}
        link={link}
        name={name}
        onClick={onClick}
        size={size}
      />
      {subDescription && (
        <Typography styleName="sub-description" tag="span">
          {subDescription}
        </Typography>
      )}

      <div className="product-description__right-column">
        {code && <ProductCode code={code} />}
        <div
          className="product-description__product-tags"
          styleName="product-tags"
        >
          {gbb && (
            <div styleName="gbb">
              <ProductGBB
                showGBBTooltip={showGBBTooltip}
                value={getNormalizedGBB(gbb)}
              />
            </div>
          )}
          {isOE && (
            <Typography
              size="extraSmall"
              styleName="original-equipment-tire"
              tag="span"
            >
              Original Equipment Tire
            </Typography>
          )}
        </div>
      </div>

      {showRating && (
        <StarRating
          rating={totalRating}
          showRatingNotAvailable
          styleName="rating"
        />
      )}
    </div>
  );
}

export default ProductDescription;
